export default {
  name: "nombre",
  extension: "extension",
  date: "fecha",
  email: "correo",
  number: "numero",
  dateStart: "desde",
  dateEnd: "hasta",
  agent: "agente",
  dateEnd: "hasta",
  userId: "agente",
};
